import { useState, useEffect } from "react";

export type Plan = "free" | "pro" | "enterprise";

export interface SubscriptionInfo {
  plan: Plan;
  status: string;
  generationCount: number;
  limit: number;
  resetAt: number;
}

export function useSubscription(userId?: string) {
  const [subscription, setSubscription] = useState<SubscriptionInfo | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    if (!userId) {
      setSubscription(null);
      setLoading(false);
      return;
    }

    try {
      const res = await fetch("/api/user/subscription");
      if (res.ok) {
        const data = await res.json();
        setSubscription(data);
      }
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void refresh();
  }, [userId]);

  return { subscription, loading, refresh };
}
